import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const BranchPLPage = lazy(() => import("@/pages/reports.branch-pl.page"));

export const Route = createFileRoute("/reports/branch-pl")({
  component: BranchPLPage,
});
